import { getMealtimesCategoryIds } from 'src/components/PublishModal/SummaryView/getMealtimesCategoryIds/getMealtimesCategoryIds';
import { IMealtime } from 'src/types/mealtimes.types';

export const isCategoryAssignedToMealtime = (categoryId: string, mealtimes: IMealtime[]): boolean => {
  const allMealtimesCategoryIds = getMealtimesCategoryIds(mealtimes);

  return allMealtimesCategoryIds.includes(categoryId);
};
